import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyAutomationDiscoveryHoverPageTitleMessage: LoadableType<{
	spaceKey: string | null | undefined;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutomationDiscoveryHoverPageTitleMessage" */ '../src/AutomationDiscoveryHoverPageTitleMessage.tsx'
			)
		).AutomationDiscoveryHoverPageTitleMessage,
});
